import { AccessAlarm, CheckCircleOutlineRounded } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useState, useEffect, useCallback } from 'react';
import { Container, CountDown } from './styles';

export const SuccessOAuthZoom = () => {
  const [authorizationCode, setAuthorizationCode] = useState<string | null>(
    null,
  );
  const [totalTimeInSeconds, setTotalTimeInSeconds] = useState(5);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    setAuthorizationCode(code);
  }, [authorizationCode]);

  useEffect(() => {
    if (authorizationCode && authorizationCode.length > 0) {
      window.opener.postMessage({ authorizationCode });
      setTimeout(() => {
        window.close();
      }, 5000);
    }
  }, [authorizationCode]);

  useEffect(() => {
    if (totalTimeInSeconds === 0) {
      setTotalTimeInSeconds(0);
    } else {
      setTimeout(() => {
        setTotalTimeInSeconds(totalTimeInSeconds - 1);
      }, 1000);
    }
  }, [totalTimeInSeconds]);

  const getTimeToResend = useCallback((): string => {
    const minutes = Math.floor(totalTimeInSeconds / 60);
    const seconds = totalTimeInSeconds % 60;
    return `0${minutes?.toFixed(0)}: ${
      seconds >= 10 ? seconds : `0${seconds}`
    }`;
  }, [totalTimeInSeconds]);

  return (
    <Box width="100vw" height="100vh" padding="20px">
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        gap="10px"
        height="90%"
        justifyContent="center"
      >
        <CheckCircleOutlineRounded
          color="success"
          sx={{ width: '66px', height: '66px' }}
        />

        <Container display="flex" flexDirection="column">
          <span className="title">Autenticação finalizada com sucesso!</span>
          <CountDown>
            <span>Esta página irá fechar automaticamente em:</span>
            <Box display="flex" alignItems="center" gap="5px">
              {getTimeToResend()}...
            </Box>
          </CountDown>
          <span>Caso a página não feche sozinha, clique no botão abaixo</span>

          <Button
            variant="outlined"
            color="success"
            sx={{ marginTop: '10px' }}
            onClick={() => window.close()}
          >
            Ok, fechar
          </Button>
        </Container>
      </Box>
    </Box>
  );
};
